module.exports = __webpack_public_path__ + "static/img/mypage.8522893c.svg";